import axiosClient from 'utils/axios';

const endPoint = '/discover-categories';

export default {
  async getDiscoverCategories(payload) {
    const response = await axiosClient.get(endPoint, {
      params: payload,
    });
    return response.data;
  },

  async getDiscoverCategoryDetails(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.get(path);
    return response.data;
  },

  async updateDiscoverCategory(id, payload) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.put(path, payload);
    return response.data;
  },

  async createDiscoverCategory(payload) {
    const path = `${endPoint}`;
    const response = await axiosClient.post(path, payload);
    return response.data;
  },

  async deleteDiscoverCategory(id) {
    const path = `${endPoint}/${id}`;
    const response = await axiosClient.delete(path);
    return response.data;
  },
};
